import React from 'react';
import Modal from 'components/modal';
import { useRecoilState, useRecoilValue } from 'recoil';
import { endPoints } from 'api/endpoints';
import axios from 'api/request';
import { useMutation } from 'react-query';
import { toggleSspModels, OrderPayload, toggleConfirmModel, currentSelection, invalidMember, memberForm, costApiLoading } from 'pages/myidm/store';
// import DeleteIcon from '@mui/icons-material/Delete';
import deleteIcon from 'assets/images/delete_icon.svg';
import MultipleAddMemberForm from 'pages/myidm/components/Form/multiple/MultipleAddMemberForm';
import AddLdapMemberSearch from 'pages/myidm/components/Form/AddLdapMemberSearch';
import { Box, TableContainer, Table, TableBody, TableHead, CircularProgress, Dialog, DialogContent, Typography, Button } from '@mui/material';
import { FiAlertTriangle } from 'react-icons/fi';
import { Styles, StyledTableCell, StyledTableRow, ActionStyledTableRow } from 'pages/myidm/style';
import Btn from 'components/button';
import { InputInfo } from 'pages/myidm/components/input-info';
import { AD_GROUP, LDAP_GROUP, PRIVILEGED } from 'pages/myidm/utils/constant';
import { commonStyles as style } from 'assets/style';

const MultipleMembersListModal = () => {
    const [isModelOpen, setModelOpen] = useRecoilState(toggleSspModels);
    // const [members, setMembers] = useRecoilState(selectedMembersList);
    const [modal, setModal] = useRecoilState(toggleConfirmModel);
    const [current, setCurrent] = useRecoilState(currentSelection);
    const [, setInvalid] = useRecoilState(invalidMember);
    const [form, setForm] = useRecoilState(memberForm);
    const [isLoading, setLoading] = React.useState(false);
    const [isCancelLoading, setCancelLoading] = React.useState(false);
    const [order, setOrder] = useRecoilState(OrderPayload);
    const isCostApiLoading = useRecoilValue(costApiLoading);
    const adGroupMembersApi = useMutation((param) => axios.get(`${endPoints?.myIdm?.adGroupMembersApi}/${param?.adGroup}`));
    const index = isModelOpen?.index || 0;
    const groupMembers = order?.multipleAdGroups?.[index]?.members || [];
    const [localMembers, setLocalMembers] = React.useState(groupMembers);

    const handleCloseModal = () => {
        setModelOpen({ ...isModelOpen, isMultipleMemberlist: false });
        setForm({
            ...form,
            member: null,
            selectedMember: null,
        });
        setOrder({
            ...order,
            adGrpMember: null,
            adGrpMemberDetails: null,
            crossDomainUser: null,
            adGrpMemberValidation: { isValid: false, message: null },
            serviceAccount: '',
            serviceAccountValidation: { isValid: false, message: '' },
        });
    };
    const handleDelete = (member) => {
        setLocalMembers((prev) => prev.filter((m) => m.gpid !== member.gpid));
        setCurrent(null);
        setModal({ ...modal, isOpen: false, message: '', action: false });
        if (localMembers.length === 1) setInvalid(true);
    };

    React.useEffect(() => {
        if (modal?.action && current?.gpid) {
            handleDelete(current);
        }
        // eslint-disable-next-line
    }, [modal.action]);

    const handleSavingMembers = () => {
        setLoading(true);
        const updatedMultipleAdGroups = [...(order?.multipleAdGroups || [])];
        if (updatedMultipleAdGroups[index]) {
            updatedMultipleAdGroups[index] = {
                ...updatedMultipleAdGroups[index],
                members: localMembers,
            };
        }
        setOrder({ ...order, multipleAdGroups: updatedMultipleAdGroups });
        setModelOpen({ ...isModelOpen, isMultipleMemberlist: false });
        setLoading(false);
    };
    const handleCancelRequest = () => {
        setCancelLoading(true);
        setModelOpen({ ...isModelOpen, isMultipleMemberlist: false });
        setCancelLoading(false);
        setForm({
            ...form,
            member: null,
            selectedMember: null,
        });
    };
    React.useEffect(() => {
        if (isModelOpen?.isMultipleMemberlist) {
            setLocalMembers(order?.multipleAdGroups?.[index]?.members || []);
        }
    }, [isModelOpen?.isMultipleMemberlist?.toString()]);
    React.useEffect(() => {
        if (isModelOpen?.isMultipleMemberlist) {
            const adGroup = order?.multipleAdGroups?.[index]?.adGroup;
            if (adGroup) {
                adGroupMembersApi.mutate(
                    { adGroup },
                    {
                        onSuccess: (data) => {
                            setOrder((prevOrder) => ({ ...prevOrder, adGroupMembers: data?.data }));
                        },
                    }
                );
            }
        }
    }, [isModelOpen?.isMultipleMemberlist?.toString()]);
    const membersCount = localMembers?.length;
    const isPrivileged = order?.multipleAdGroups?.[index]?.adGroupType === PRIVILEGED;
    // Confirm modal state for delete
    const [confirmModal, setConfirmModal] = React.useState({ isOpen: false, message: '', memberIdx: null });

    // Open confirm modal for delete
    const handleOpenDeleteModal = (member, memberIdx) => {
        setConfirmModal({
            isOpen: true,
            message: `Are you sure you want to remove ${member?.name ? member?.name : member?.gpid} ?`,
            memberIdx,
        });
    };

    // Handle confirm modal actions
    const handleConfirmYes = () => {
        if (confirmModal.memberIdx !== null) {
            setLocalMembers((prev) => prev.filter((_, idx) => idx !== confirmModal.memberIdx));
            setCurrent(null);
            if (localMembers.length === 1) setInvalid(true);
        }
        setConfirmModal({ isOpen: false, message: '', memberIdx: null });
    };
    const handleConfirmNo = () => {
        setConfirmModal({ isOpen: false, message: '', memberIdx: null });
    };

    return (
        <>
            <Modal
                title="Members List"
                handleClose={() => handleCloseModal()}
                open={isModelOpen?.isMultipleMemberlist}
                width="45%"
                showinfoIcon
                infoIcon={
                    <>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <InputInfo
                                title={
                                    <>
                                        Service accounts can only be added to <b>non-privileged Active Directory groups</b>. This functionality is not available
                                        for privileged Active Directory groups.
                                    </>
                                }
                            />
                        </Box>
                    </>
                }
            >
                <>
                    <Box
                        sx={{
                            minWidth: (theme) => theme.spacing(60),
                            width: 'auto',
                            display: 'flex',
                            height: '100%',
                            flexDirection: 'column',
                            overflow: 'hidden',
                        }}
                    >
                        <Box sx={{ overflow: 'auto', pt: (theme) => theme.spacing(2), height: '100%' }}>
                            {order?.groupType === AD_GROUP && (
                                <MultipleAddMemberForm index={index} localMembers={localMembers} setLocalMembers={setLocalMembers} />
                            )}
                            {order?.groupType === LDAP_GROUP && <AddLdapMemberSearch />}
                            <Box>
                                <TableContainer sx={Styles?.AddMemberForm?.table.tableWrapper}>
                                    <Table sx={{ ...Styles?.AddMemberForm?.table?.main, height: 'auto', borderSpacing: 0 }} size="small" stickyHeader>
                                        {localMembers?.length > 0 && (
                                            <TableHead>
                                                <StyledTableRow>
                                                    <StyledTableCell sx={{ backgroundColor: '#E5F5FC !important' }}>GPID</StyledTableCell>
                                                    <StyledTableCell sx={{ backgroundColor: '#E5F5FC !important' }}>Full Name</StyledTableCell>
                                                    <StyledTableCell sx={{ backgroundColor: '#E5F5FC !important' }}>Email ID</StyledTableCell>
                                                    {isPrivileged && (
                                                        <StyledTableCell sx={{ backgroundColor: '#E5F5FC !important' }}>Secondary Account</StyledTableCell>
                                                    )}
                                                    <StyledTableCell aria-label="action" sx={{ backgroundColor: '#E5F5FC !important' }}>
                                                        &nbsp;
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                            </TableHead>
                                        )}
                                        <TableBody>
                                            <ActionStyledTableRow>
                                                {localMembers?.length < 1 && <StyledTableCell>No members selected.</StyledTableCell>}
                                            </ActionStyledTableRow>
                                            {localMembers?.length > 0 ? (
                                                <>
                                                    {!localMembers.loading &&
                                                        localMembers?.map((member, idx) => (
                                                            <StyledTableRow className="animate-opacity" key={member?.gpid}>
                                                                <StyledTableCell>{member?.gpid || ''}</StyledTableCell>
                                                                <StyledTableCell>{member?.name || '-'}</StyledTableCell>
                                                                <StyledTableCell>{member?.email || '-'}</StyledTableCell>
                                                                {isPrivileged && (
                                                                    <StyledTableCell>{member?.secondaryAccount?.secondaryAccountName || '-'}</StyledTableCell>
                                                                )}
                                                                <StyledTableCell onClick={() => handleOpenDeleteModal(member, idx)}>
                                                                    <img style={Styles?.AddMemberForm?.removeBtn} src={deleteIcon} alt="deleteIcon" />
                                                                </StyledTableCell>
                                                            </StyledTableRow>
                                                        ))}
                                                </>
                                            ) : null}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Box>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', p: (theme) => theme.spacing(2) }}>
                            {(membersCount > 0 || order?.members?.length > 0) && (
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'right' }}>
                                    <Btn
                                        variant="contained"
                                        color="cmpPrimary"
                                        onClick={() => handleSavingMembers()}
                                        /*   sx={{
                                            width: (theme) => theme.spacing(15.75),
                                            height: (theme) => theme.spacing(4.375),
                                            marginBottom: 1,
                                            marginRight: 1,
                                        }} */
                                        sx={{ ...style.modalSaveButton, marginRight: '8px', marginBottom: '8px', width: '130px' }}
                                        disabled={isLoading || isCostApiLoading}
                                    >
                                        {isLoading ? <CircularProgress color="inherit" size={16} /> : 'Save'}
                                    </Btn>
                                    <Btn
                                        onClick={() => handleCancelRequest()}
                                        // color="cmpPrimary"
                                        variant="outlined"
                                        /*   sx={{
                                            width: (theme) => theme.spacing(15.75),
                                            height: (theme) => theme.spacing(4.375),
                                            marginBottom: 1,
                                        }} */
                                        sx={{ ...style.modalCancelButton, marginRight: '8px', marginBottom: '8px', width: '130px' }}
                                        data-testId="cancel-btn"
                                    >
                                        {isCancelLoading ? <CircularProgress color="inherit" size={16} /> : 'Cancel'}
                                    </Btn>
                                </Box>
                            )}
                        </Box>
                    </Box>
                </>
            </Modal>
            {/* Confirm Delete Modal */}
            <Dialog open={confirmModal.isOpen} onClose={handleConfirmNo} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                <DialogContent
                    sx={{
                        maxWidth: '375px',
                        border: (theme) => `10px solid ${theme.palette.border.$color_border_default}`,
                    }}
                >
                    <Box display="flex" flexDirection="column" alignItems="center" style={{ textAlign: 'center' }}>
                        <FiAlertTriangle color="#d02424" size={70} />
                        <Typography variant="h5">{confirmModal.message}</Typography>
                    </Box>
                    <Box display="flex" justifyContent="center" mt={2}>
                        <Button
                            sx={style.modalSaveButton}
                            variant="contained"
                            onClick={handleConfirmYes}
                            className="uppercase tracking-wider text-sm"
                            data-testid="confirmYes"
                        >
                            Yes
                        </Button>
                        <Button
                            variant="outlined"
                            style={{ marginLeft: '10px' }}
                            sx={style.modalCancelButton}
                            onClick={handleConfirmNo}
                            layout="outline"
                            className="uppercase tracking-wider text-sm"
                            data-testid="confirmNo"
                        >
                            No
                        </Button>
                    </Box>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default React.memo(MultipleMembersListModal);
